import React, { useState, useEffect } from 'react';
import { apiRequest } from '../../utils/apiHelper';
import { formatPrice } from '../../utils/formatHelper';

import Select from 'react-select/async';
import ActionDrawer from '../components/shared/ActionDrawer';
import { showSuccess, showError, showInfo } from '../../utils/toastHelper';

function CreateFreeSubscriptionModal({ isOpen, onClose, onSuccess, editSubscription = null }) {
  const [loading, setLoading] = useState(false);
  // ... existing state ...
  const [formData, setFormData] = useState({
    userId: '',
    interval: 'MONTHLY',
    products: [],
    shippingAddress: {
      fullName: '',
      address: '',
      city: '',
      district: '',
      country: 'Turkey',
      phone: '',
      zipCode: ''
    },
    billingAddress: {
      fullName: '',
      address: '',
      city: '',
      district: '',
      country: 'Turkey',
      phone: '',
      zipCode: ''
    },
    startDate: new Date().toISOString().split('T')[0],
    notes: ''
  });

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [copyShippingToBilling, setCopyShippingToBilling] = useState(true);
  const [errorDetails, setErrorDetails] = useState('');

  // Edit subscription data population
  useEffect(() => {
    if (!editSubscription && !onClose) return;

    if (editSubscription) {
      console.log(editSubscription.interval);
      // Populate form data when editing
      setFormData({
        userId: editSubscription.userId || '',
        interval: editSubscription.interval || 'MONTHLY',
        products: (editSubscription.products || []).map(product => ({
          id: product.id,
          name: product.name,
          quantity: product.quantity || 1,
          mainImage: product.mainImage,
          price: product.price,
          discountPrice: product.discountPrice
        })),
        shippingAddress: {
          fullName: editSubscription.shippingAddress?.fullName || '',
          address: editSubscription.shippingAddress?.address || '',
          city: editSubscription.shippingAddress?.city || '',
          district: editSubscription.shippingAddress?.district || '',
          country: editSubscription.shippingAddress?.country || 'Turkey',
          phone: editSubscription.shippingAddress?.phone || '',
          zipCode: editSubscription.shippingAddress?.zipCode || ''
        },
        billingAddress: {
          fullName: editSubscription.billingAddress?.fullName || '',
          address: editSubscription.billingAddress?.address || '',
          city: editSubscription.billingAddress?.city || '',
          district: editSubscription.billingAddress?.district || '',
          country: editSubscription.billingAddress?.country || 'Turkey',
          phone: editSubscription.billingAddress?.phone || '',
          zipCode: editSubscription.billingAddress?.zipCode || ''
        },
        startDate: editSubscription.startDate ? editSubscription.startDate.split('T')[0] : new Date().toISOString().split('T')[0],
        notes: editSubscription.notes || ''
      });

      // Set selected products for the multi-select
      setSelectedProducts((editSubscription.products || []).map(product => ({
        value: product.id,
        label: product.name,
        product: {
          id: product.id,
          name: product.name,
          price: product.price,
          mainImage: product.mainImage,
          discountPrice: product.discountPrice
        }
      })));

      // Set selected user
      if (editSubscription.user) {
        setSelectedUser({
          value: editSubscription.userId,
          label: `${editSubscription.user.fullName || ''} (${editSubscription.user.email || ''})`,
          user: editSubscription.user
        });
      } else {
        setSelectedUser(null);
      }
    }
  }, [editSubscription, isOpen]);

  // Kullanıcıları yükle 
  const loadUsers = async (inputValue) => {
    try {
      const queryParams = new URLSearchParams({
        search: inputValue || '',
        page: 1,
        limit: 100,
        status: 'ACTIVE'
      });

      const response = await apiRequest(`/admin/users?${queryParams.toString()}`);

      if (response.success) {
        return response.users.map(user => ({
          value: user.id,
          label: `${user.fullName} (${user.email})`,
          user: user
        }));
      }
      return [];
    } catch (error) {
      console.error('Kullanıcılar yüklenirken hata:', error);
      showError('Kullanıcılar yüklenirken bir hata oluştu');
      return [];
    }
  };

  // Ürünleri yükle
  const loadProducts = async (inputValue) => {
    try {
      const queryParams = new URLSearchParams({
        search: inputValue || '',
        page: 1,
        limit: 50,
        status: 'ACTIVE'
      });

      const response = await apiRequest(`/products?${queryParams.toString()}`);

      if (response.success) {
        return response.products.map(product => ({
          value: product.id,
          label: product.name,
          product: product
        }));
      }
      return [];
    } catch (error) {
      console.error('Ürünler yüklenirken hata:', error);
      showError('Ürünler yüklenirken bir hata oluştu');
      return [];
    }
  };

  // Form değişikliklerini yönet
  const handleChange = (e, section = null) => {
    const { name, value } = e.target;

    if (section) {
      setFormData(prev => ({
        ...prev,
        [section]: {
          ...prev[section],
          [name]: value
        }
      }));

      if (section === 'shippingAddress' && copyShippingToBilling) {
        setFormData(prev => ({
          ...prev,
          billingAddress: {
            ...prev.billingAddress,
            [name]: value
          }
        }));
      }
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  // Kullanıcı seçimi değişikliğini yönet
  const handleUserChange = (selectedOption) => {
    setSelectedUser(selectedOption);
    if (selectedOption) {
      const user = selectedOption.user;
      setFormData(prev => ({
        ...prev,
        userId: user.id,
        shippingAddress: {
          fullName: user.fullName || '',
          address: user.address || '',
          city: user.city || '',
          district: user.district || '',
          country: 'Turkey',
          phone: user.phone || '',
          zipCode: user.zipCode || ''
        },
        billingAddress: {
          fullName: user.fullName || '',
          address: user.address || '',
          city: user.city || '',
          district: user.district || '',
          country: 'Turkey',
          phone: user.phone || '',
          zipCode: user.zipCode || ''
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        userId: '',
        shippingAddress: {
          fullName: '',
          address: '',
          city: '',
          district: '',
          country: 'Turkey',
          phone: '',
          zipCode: ''
        },
        billingAddress: {
          fullName: '',
          address: '',
          city: '',
          district: '',
          country: 'Turkey',
          phone: '',
          zipCode: ''
        }
      }));
    }
  };

  // Ürün miktarını güncelle
  const updateProductQuantity = (productId, quantity) => {
    setFormData(prev => {
      const updatedProducts = prev.products.map(product =>
        product.id === productId
          ? { ...product, quantity: Math.max(1, parseInt(quantity) || 1) }
          : product
      );
      return {
        ...prev,
        products: updatedProducts
      };
    });
  };

  // Ürün seçimi değişikliğini yönet
  const handleProductChange = (selectedOptions) => {
    setSelectedProducts(selectedOptions || []);
    const selectedProductsData = (selectedOptions || []).map(option => ({
      id: option.product.id,
      name: option.product.name,
      quantity: 1,
      price: option.product.price,
      mainImage: option.product.mainImage,
      discountPrice: option.product.discountPrice
    }));
    setFormData(prev => ({
      ...prev,
      products: selectedProductsData
    }));
  };

  // Formu gönder
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    if (formData.products.length === 0) {
      showError('En az bir ürün seçmelisiniz');
      return;
    }

    try {
      setLoading(true);
      setErrorDetails(''); // Hata detaylarını temizle

      let response;
      if (editSubscription) {
        // Update existing subscription
        response = await apiRequest(`/subscriptions/${editSubscription.userId}/update-free-subscription`, {
          method: 'PUT',
          data: {
            products: formData.products.map(product => ({
              id: product.id,
              quantity: product.quantity,
              name: product.name,
              mainImage: product.mainImage
            })),
            interval: formData.interval,
            shippingAddress: formData.shippingAddress,
            billingAddress: formData.billingAddress,
            notes: formData.notes
          }
        });
      } else {
        // Create new subscription
        response = await apiRequest('/admin/subscriptions/free', {
          method: 'POST',
          data: formData
        });
      }

      if (response.success) {
        showSuccess(editSubscription ? 'Abonelik başarıyla güncellendi' : 'Ücretsiz abonelik başarıyla oluşturuldu');
        onSuccess && onSuccess();
        onClose();
      } else {
        throw new Error(response.message || 'İşlem sırasında bir hata oluştu');
      }
    } catch (error) {
      console.error('Failed to process subscription:', error);

      // Hata detaylarını ayarla
      if (error.data?.details) {
        setErrorDetails(error.data.details);
      }

      if (error.apiError) {
        showError(
          'Sunucuya ulaşılamıyor. Lütfen internet bağlantınızı kontrol edin veya tekrar deneyin.',
          {
            autoClose: false,
            closeOnClick: false,
            draggable: false,
            closeButton: true
          }
        );
      } else {
        showError(error.message || 'İşlem sırasında bir hata oluştu');
      }
    } finally {
      setLoading(false);
    }
  };

  // Modal kapatıldığında formu sıfırla
  const handleClose = () => {
    setFormData({
      userId: '',
      interval: 'MONTHLY',
      products: [],
      shippingAddress: {
        fullName: '',
        address: '',
        city: '',
        district: '',
        country: 'Turkey',
        phone: '',
        zipCode: ''
      },
      billingAddress: {
        fullName: '',
        address: '',
        city: '',
        district: '',
        country: 'Turkey',
        phone: '',
        zipCode: ''
      },
      startDate: new Date().toISOString().split('T')[0],
      notes: ''
    });
    setSelectedProducts([]);
    setSelectedUser(null);
    setCopyShippingToBilling(true);
    setErrorDetails(''); // Hata detaylarını temizle
    onClose();
  };

  const footer = (
    <div className="d-flex justify-content-end gap-2 w-100">
      <button type="button" className="btn btn-light border" onClick={handleClose}>
        İptal
      </button>
      <button
        type="button"
        className="btn btn-dark"
        disabled={loading}
        onClick={handleSubmit}
      >
        {loading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {editSubscription ? 'Güncelleniyor...' : 'Oluşturuluyor...'}
          </>
        ) : (
          editSubscription ? 'Kaydet' : 'Oluştur'
        )}
      </button>
    </div>
  );

  return (
    <ActionDrawer
      isOpen={isOpen}
      onClose={handleClose}
      title={editSubscription ? "Abonelik Düzenle" : "Ücretsiz Abonelik Oluştur"}
      width="900px"
      footer={footer}
    >
      <form onSubmit={handleSubmit} className="subscription-form-content">
        <div className="row g-3">
          {/* Müşteri Seçimi ve Interval */}
          <div className="col-md-6">
            <label className="form-label">Müşteri</label>
            <Select
              value={selectedUser}
              onChange={handleUserChange}
              loadOptions={loadUsers}
              defaultOptions
              cacheOptions
              placeholder="Müşteri ara..."
              noOptionsMessage={() => "Müşteri bulunamadı"}
              loadingMessage={() => "Yükleniyor..."}
              className="react-select-container"
              classNamePrefix="react-select"
              isClearable
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Teslimat Sıklığı</label>
            <select
              className="form-select"
              name="interval"
              value={formData.interval}
              onChange={handleChange}
              required
            >
              <option value="MONTHLY">Aylık</option>
              <option value="BIWEEKLY">2 Haftalık</option>
            </select>
          </div>

          {/* Ürün Seçimi */}
          <div className="col-12">
            <label className="form-label">Ürünler</label>
            <Select
              isMulti
              value={selectedProducts}
              onChange={handleProductChange}
              loadOptions={loadProducts}
              defaultOptions
              cacheOptions
              placeholder="Ürün ara..."
              noOptionsMessage={() => "Ürün bulunamadı"}
              loadingMessage={() => "Yükleniyor..."}
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>

          {/* Seçili Ürünler Listesi */}
          {formData.products.length > 0 && (
            <div className="col-12">
              <div className="table-responsive">
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Ürün</th>
                      <th style={{ width: '120px' }}>Miktar</th>
                      <th className="d-none d-md-table-cell">Fiyat</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.products.map(product => (
                      <tr key={product.id}>
                        <td>
                          <div className="d-flex align-items-center">
                            {product.mainImage && (
                              <img
                                src={product.mainImage}
                                alt={product.name}
                                className="product-image me-2"
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                }}
                              />
                            )}
                            <div className="d-flex flex-column">
                              <span className="fw-medium">{product.name}</span>
                              <small className="text-muted d-md-none">{formatPrice(product.price)}</small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            value={product.quantity}
                            onChange={(e) => updateProductQuantity(product.id, e.target.value)}
                            min="1"
                            style={{ minWidth: '60px' }}
                          />
                        </td>
                        <td className="d-none d-md-table-cell">{formatPrice(product.price)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Teslimat Adresi */}
          <div className="col-12">
            <h6 className="mb-3">Teslimat Adresi</h6>
            <div className="row g-3">
              <div className="col-12">
                <label className="form-label">Ad Soyad</label>
                <input
                  type="text"
                  className="form-control"
                  name="fullName"
                  value={formData.shippingAddress.fullName}
                  onChange={(e) => handleChange(e, 'shippingAddress')}
                  required
                />
              </div>
              <div className="col-12">
                <label className="form-label">Adres</label>
                <textarea
                  className="form-control"
                  name="address"
                  value={formData.shippingAddress.address}
                  onChange={(e) => handleChange(e, 'shippingAddress')}
                  required
                ></textarea>
              </div>
              <div className="col-md-6">
                <label className="form-label">İl</label>
                <input
                  type="text"
                  className="form-control"
                  name="city"
                  value={formData.shippingAddress.city}
                  onChange={(e) => handleChange(e, 'shippingAddress')}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">İlçe</label>
                <input
                  type="text"
                  className="form-control"
                  name="district"
                  value={formData.shippingAddress.district}
                  onChange={(e) => handleChange(e, 'shippingAddress')}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Ülke</label>
                <input
                  type="text"
                  className="form-control"
                  name="country"
                  value={formData.shippingAddress.country}
                  onChange={(e) => handleChange(e, 'shippingAddress')}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Telefon</label>
                <input
                  type="tel"
                  className="form-control"
                  name="phone"
                  value={formData.shippingAddress.phone}
                  onChange={(e) => handleChange(e, 'shippingAddress')}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Posta Kodu</label>
                <input
                  type="text"
                  className="form-control"
                  name="zipCode"
                  value={formData.shippingAddress.zipCode}
                  onChange={(e) => handleChange(e, 'shippingAddress')}
                  placeholder="34000"
                />
              </div>
            </div>
          </div>

          {/* Fatura Adresi Checkbox */}
          <div className="col-12">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="copyAddress"
                checked={copyShippingToBilling}
                onChange={(e) => setCopyShippingToBilling(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="copyAddress">
                Fatura adresi teslimat adresi ile aynı
              </label>
            </div>
          </div>

          {/* Fatura Adresi */}
          {!copyShippingToBilling && (
            <div className="col-12">
              <h6 className="mb-3">Fatura Adresi</h6>
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label">Ad Soyad</label>
                  <input
                    type="text"
                    className="form-control"
                    name="fullName"
                    value={formData.billingAddress.fullName}
                    onChange={(e) => handleChange(e, 'billingAddress')}
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Adres</label>
                  <textarea
                    className="form-control"
                    name="address"
                    value={formData.billingAddress.address}
                    onChange={(e) => handleChange(e, 'billingAddress')}
                    required
                  ></textarea>
                </div>
                <div className="col-md-6">
                  <label className="form-label">İl</label>
                  <input
                    type="text"
                    className="form-control"
                    name="city"
                    value={formData.billingAddress.city}
                    onChange={(e) => handleChange(e, 'billingAddress')}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">İlçe</label>
                  <input
                    type="text"
                    className="form-control"
                    name="district"
                    value={formData.billingAddress.district}
                    onChange={(e) => handleChange(e, 'billingAddress')}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Ülke</label>
                  <input
                    type="text"
                    className="form-control"
                    name="country"
                    value={formData.billingAddress.country}
                    onChange={(e) => handleChange(e, 'billingAddress')}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Telefon</label>
                  <input
                    type="tel"
                    className="form-control"
                    name="phone"
                    value={formData.billingAddress.phone}
                    onChange={(e) => handleChange(e, 'billingAddress')}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Posta Kodu</label>
                  <input
                    type="text"
                    className="form-control"
                    name="zipCode"
                    value={formData.billingAddress.zipCode}
                    onChange={(e) => handleChange(e, 'billingAddress')}
                    placeholder="34000"
                  />
                </div>
              </div>
            </div>
          )}

          {/* Başlangıç Tarihi ve Notlar */}
          <div className="col-md-6">
            <label className="form-label">Başlangıç Tarihi</label>
            <input
              type="date"
              className="form-control"
              name="startDate"
              value={formData.startDate}
              onChange={handleChange}
            />
          </div>
          <div className="col-12">
            <label className="form-label">Notlar</label>
            <textarea
              className="form-control"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Opsiyonel notlar..."
              rows="2"
            ></textarea>
          </div>

          {/* Hata Detayları */}
          {errorDetails && (
            <div className="col-12">
              <div className="alert alert-danger" role="alert">
                <div className="d-flex align-items-start">
                  <i className="fas fa-exclamation-triangle me-2 mt-1"></i>
                  <div>
                    <strong>Hata Detayları:</strong>
                    <p className="mb-0 mt-1">{errorDetails}</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <style>{`
          .react-select-container {
            width: 100%;
            opacity: 1;
          }

          .react-select__control {
            min-height: 38px;
            border-color: #ced4da;
            background-color: #fff !important;
            opacity: 1 !important;
          }

          .react-select__control:hover {
            border-color: #ced4da;
          }

          .react-select__control--is-focused {
            border-color: var(--kito-orange) !important;
            box-shadow: 0 0 0 0.25rem rgba(232, 108, 58, 0.25) !important;
          }

          .react-select__menu {
            z-index: 1060;
            background-color: #fff !important;
          }

          .react-select__option {
            background-color: #fff;
          }

          .react-select__option:hover {
            background-color: #fff8e5;
          }

          .react-select__option--is-selected {
            background-color: var(--kito-orange) !important;
          }

          .form-control, .form-select {
            background-color: #fff;
            opacity: 1;
          }

          .form-control:disabled,
          .form-select:disabled {
            background-color: #e9ecef;
            opacity: 1;
          }

          .table {
            background-color: #fff;
          }

          /* Ürün resmi stilleri */
          .product-image {
            width: 32px;
            height: 32px;
            object-fit: cover;
            border-radius: 4px;
            border: 1px solid #dee2e6;
          }
          
          @media (max-width: 767px) {
            /* Mobilde tablo responsive davranışı */
            .table-responsive {
              border: 0;
            }
            
            .table {
              margin-bottom: 0;
            }
            
            .table th,
            .table td {
              padding: 0.5rem 0.25rem;
              vertical-align: middle;
            }
            
            .table th {
              font-size: 0.8rem;
              font-weight: 600;
            }
            
            .table td {
              font-size: 0.85rem;
            }
            
            /* Mobilde ürün resmi daha küçük */
            .product-image {
              width: 24px;
              height: 24px;
            }
            
            /* Mobilde input boyutları */
            .form-control-sm {
              padding: 0.25rem 0.5rem;
              font-size: 0.85rem;
              height: auto;
              min-height: 32px;
            }
            
            /* Mobilde alert boyutları */
            .alert {
              padding: 0.75rem;
              font-size: 0.85rem;
            }
            
            .alert p {
              font-size: 0.8rem;
              line-height: 1.4;
            }
          }
        `}</style>
      </form>
    </ActionDrawer>
  );
}

export default CreateFreeSubscriptionModal; 